import React from 'react';

import { Box } from '@atlaskit/primitives';
import { cssMap } from '@atlaskit/css';

import type { Ari } from '@atlassian/ari';

import { ContentSourcesPicker } from '../../sub-components/content-sources-picker/ContentSourcesPicker';
import type { ActiveAudioContent } from '../../../../types/activeAudioContent';
import { useAudioBriefing } from '../../../../hooks/useAudioBriefing';
import { getConfluenceContentAri } from '../../../../utils/getConfluenceContentAri';

const styles = cssMap({
	container: {
		// arbitrary placeholder
		minHeight: '200px',
	},
});

export const AudioBriefingPopupSourcesPanel = () => {
	const [{ cloudId }, { setAdditionalResources }] = useAudioBriefing();

	const onContentSourcesPickerChange = (newAdditionalResources: readonly ActiveAudioContent[]) => {
		const newAris = newAdditionalResources
			.filter((resource) => !!resource.contentType)
			.map((resource) => getConfluenceContentAri(cloudId, resource.id, resource.contentType))
			.filter((ari): ari is Ari => !!ari);

		setAdditionalResources(newAris);
	};

	return (
		<Box xcss={styles.container}>
			<ContentSourcesPicker onChange={onContentSourcesPickerChange} />
		</Box>
	);
};
